<div class="relative w-full min-h-screen px-8">
  <div class="flex h-screen">
    <div class="m-auto">
      <h3>Page Under Construction</h3>
    </div>
  </div>
</div>
